/* eslint-disable import/no-mutable-exports */
let $i18n: any;

export function initializeI18n(i18nInstance: any) {
  $i18n = i18nInstance;
}

export { $i18n };
